import React from 'react'
import SuggestionsForm from '../components/SuggestionsForm/'
import Helmet from 'react-helmet'

const SuggestionsEn = () => (
  <div className="page suggestions">
  <Helmet
                title={`Send Us Your Suggestions | Budget Nicaragua`}
                meta={[
                  {
                    name: 'description',
                    content:
                      'Frequently Asked Questions about car rentals.',
                  },
                ]}
                link={[
                  {
                    rel: 'alternate',
                    hreflang: 'en',
                    href:
                      './es/suggestions',
                  },
                ]}
              />
    
    <div className="image" />
    <h1>Suggestions</h1>
    <div className="grid-wrapper">
      <div className="block-first">
        <SuggestionsForm lan="en" />
      </div>
      <div className="block-second">
        <h3>
          We want your trip with Budget Car and Truck Rental to be your best
          experience.
        </h3>
        <a className="mail" href="mailto:feedback@budget.com.ni">
        feedback@budget.com.ni
        </a>
        <a href="tel:+50522559000">+505 2255-9000</a>   
      </div>
    </div>
  </div>
)
export default SuggestionsEn



// WEBPACK FOOTER //
// ./src/pages/suggestions.en.js